import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAboutHeaderSection from "../../components/about-header/FormAboutHeaderSection";
import { useGetAboutHeaderSection } from "../../hooks/about-header/useGetAboutHeaderSection";
import { useUpdateAboutHeaderSection } from "../../hooks/about-header/useUpdateAboutHeaderSection";

const AboutHeaderSection = () => {
    const { aboutHeaderSection, isLoading: isFetching } = useGetAboutHeaderSection();
    const { mutate, isPending: isUpdating } = useUpdateAboutHeaderSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAboutHeaderSection
                currentData={aboutHeaderSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default AboutHeaderSection;
